import { render, staticRenderFns } from "./TaxiProfileCard.vue?vue&type=template&id=47459a39&scoped=true"
import script from "./TaxiProfileCard.vue?vue&type=script&lang=js"
export * from "./TaxiProfileCard.vue?vue&type=script&lang=js"
import style0 from "./TaxiProfileCard.vue?vue&type=style&index=0&id=47459a39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47459a39",
  null
  
)

export default component.exports